const TitleRankMap = {
    'Lead Portfolio Manager': 1,
    'Portfolio Manager': 2,
    'Co-Portfolio Manager': 3,
    'Associate Portfolio Manager': 4,
    'Portfolio Specialist': 5
};

export const sortByTitle = (managers) => {
    let sortedManagers = [];

    if (managers && managers.length) {
        sortedManagers = managers.sort((a, b) => {
            // if the title from the backend is missing from our map
            // then give the rank a huge number, so they end up last in line.
            const aRank = TitleRankMap[a.title] || 1000;
            const bRank = TitleRankMap[b.title] || 1000;
            return aRank - bRank;
        });
    }

    return sortedManagers;
};
